export const SIDER_COLLAPSED_LOCAL_STORAGE_KEY = 'sider_collapsed'

/**
 * サイドバーの開閉状態をローカルストレージへの保存・取得
 */
export const SiderCollapsedStorage = {
  setItem: (value: boolean) => {
    localStorage.setItem(
      SIDER_COLLAPSED_LOCAL_STORAGE_KEY,
      value ? 'true' : 'false'
    )
  },
  getItem: (): boolean => {
    const value = localStorage.getItem(SIDER_COLLAPSED_LOCAL_STORAGE_KEY)
    return value === 'true'
  }
}
